import styled, { css } from 'styled-components';
import { device } from 'commons';

export const Button = styled.button<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 130px;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
  opacity: 1;
  animation: fadeIn 1s 1;
  padding: 15px;
  animation-fill-mode: forwards;
  background-color: ${({ theme }) => theme.neutral_100};

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  ${({ $selected, theme }) =>
    $selected &&
    css`
      box-shadow: inset 0 0 0 1px ${theme.neutral_700};
    `}

  @media (max-width: ${device.mobile}px) {
    min-width: unset;
  }
`;

const alignEnd = 'align-items: flex-end;';

export const Section = styled.div<{ $alignEnd?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  gap: 4px;
  color: ${({ theme }) => theme.neutral_500};

  ${({ $alignEnd }) => $alignEnd && alignEnd}
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 4px;
  width: 100%;

  .text-end {
    text-align: end;
  }

  .nowrap {
    white-space: nowrap;
  }
`;

export const TextOverflowContainer = styled.div`
  display: grid;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  padding-right: 8px;

  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ReturnOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const iconSize = '16px';

export const ReturnOptionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${iconSize};
  min-height: ${iconSize};

  svg {
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
`;

export const Division = styled.hr`
  background-color: ${({ theme }) => theme.neutral_700};
  opacity: 0.1;
  width: 100%;
  height: 1px;
`;

export const ReturnStatus = styled.div<{ $status: string }>`
  border-radius: 50px;
  padding: 5px 15px;
  white-space: nowrap;

  ${({ theme, $status }) => {
    const statusColor =
      theme.returnStatus[$status] || theme.returnStatus['default'];

    return css`
      background-color: ${statusColor.primary};
      color: ${statusColor.secondary};
    `;
  }};
`;
